import { BookingParams } from '../../types/BookingTypes';
import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getGuestsText } from '../../services/Booking/BookingRangeService';
import { DataOptions, getDataOptions } from '../../services/DataOption/DataOptionsService';

export interface BookingRangeProps {
  bookingParams: BookingParams;
}

export const BookingRange = (props: BookingRangeProps): JSX.Element => {
  const { bookingParams } = props;
  const { numberOfAdults, numberOfChildren, agesOfChildren } = bookingParams;
  const [guestsText, setGuestsText] = useState('');
  const [dataOptions] = useState<DataOptions>(getDataOptions());
  
  useEffect(() => {
    var disableChildren = dataOptions.disableChildren;
    setGuestsText(getGuestsText({ numberOfAdults, numberOfChildren, agesOfChildren, disableChildren }));
  }, [numberOfAdults, numberOfChildren, agesOfChildren]);

  return (
    <VStack width={'100%'} borderRadius={4} borderWidth={1} spacing={1}>
      <HStack width={'100%'} alignItems={'flex-start'} borderBottomWidth={1}>
        <VStack borderRightWidth={1} p={4} width={'100%'} alignItems={'flex-start'} lineHeight={1}>
          <Text color={'gray.500'} fontSize={'sm'}>
            Anreise
          </Text>
          <Text>{moment(bookingParams.fromDate).format('dd. DD.MM.YYYY')}</Text>
        </VStack>
        <VStack p={4} width={'100%'} alignItems={'flex-start'} lineHeight={1}>
          <Text color={'gray.500'} fontSize={'sm'}>
            Abreise
          </Text>
          <Text>{moment(bookingParams.toDate).format('dd. DD.MM.YYYY')}</Text>
        </VStack>
      </HStack>
      <VStack p={4} width={'100%'} alignItems={'flex-start'} lineHeight={1}>
        <Text color={'gray.500'} fontSize={'sm'}>
          Gäste
        </Text>
        <Box>{guestsText}</Box>
      </VStack>
    </VStack>
  );
};
